/* eslint-disable react-hooks/exhaustive-deps */
import { getFromLS, isAdmin, isAuthenticated } from '@orientaction/utils';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { setDefaultStrapiRole } from '../../../../services/user.service';
import { AuthLayout } from '../components/AuthLayout';
import LoginForm from './LoginForm';

const Login = () => {
  const history = useHistory();
  const user = getFromLS('userInfos') ? JSON.parse(getFromLS('userInfos') || '') : undefined;

  useEffect(() => {
    const checkSession = async () => {
      const isValidConnexion = isAuthenticated();
      let mainLink = '/admin/users-resultats';
      if (isAdmin(user)) {
        if (user?.allowed_services) {
          const services = user?.allowed_services.map((i: { id: string }) => i.id);
          if (services.length === 1 && services[0] === 4) {
            mainLink = '/admin/emploi/board';
          }
        }
      } else {
        mainLink = '/main';
      }

      if (isValidConnexion) {
        if (!user.role) {
          const token = getFromLS('userToken') ?? '';
          await setDefaultStrapiRole(user.id, token);
        }
        history.replace(mainLink);
      }
    };
    checkSession();
  }, []);

  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};

export default Login;
